import { render, staticRenderFns } from "./SkillDiagnosisPopup.vue?vue&type=template&id=1ad1908a"
import script from "./SkillDiagnosisPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./SkillDiagnosisPopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/aptitude/skill-diagnosis-popup.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports